












































helpers = require('../../helpers.coffee')

view_model =
  props: ['user']

  data: ->
    replace_user_id: null
    users: null

  computed:
    user_options: ->
      if @users
        options = [{value: null, text: 'Selecione um usuário'}]
        for user in @users
          options.push({value: user.id, text: user.name}) if user.id != @user.id
        options
      else
        [{value: null, text: 'Carregando...'}]

  methods:
    destroyUser: ->
      @$validator.validateAll({@replace_user_id}).then =>
        Loader.on()
        new UsersResource().destroy(@destroyUserSuccess, @handleApiErrors, id: @user.id, params: {@replace_user_id})

    destroyUserSuccess: ->
      Loader.off()
      IntercomCtrl.trackEvent('Excluiu um usuário', { id: @user.id, name: @user.name, email: @user.email })
      alertify.success 'Usuário excluído com sucesso'
      jQuery('#destroy-user-modal').modal('hide')
      @$emit('destroyed', @user)

    successLoadUsers: (resource) ->
      @users = resource.users

  watch:
    user: ->
      @errors.clear()
      @users = null
      @replace_user_id = null
      new UsersResource().index(@successLoadUsers, @unknownError, params: {company_id: @user.company_id})

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/users/destroy_modal.vue